import { produce } from 'immer';
import { notifyActionTypes } from './notify.types';

let nextNotifyId = 0;

const initialState = {
    id: 0,
    visible: false,
    message: '',
    timestamp: null,
};

const notifyReducer = (state = initialState, action) => {
    if (state.isStoredState) {
        state = { ...initialState, ...state, isStoredState: false };
    }

    return produce(state, (draft) => {
        switch (action.type) {
            case notifyActionTypes.SHOW_NOTIFY: {
                draft.timestamp = Date.now();
                draft.message = action.payload.message;
                draft.visible = true;
                draft.id = ++nextNotifyId;
                break;
            }
            case notifyActionTypes.HIDE_NOTIFY: {
                draft.visible = false;
                break;
            }

            default:
                break;
        }
    });
};

export default notifyReducer;
